import React, { FunctionComponent } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { CSSTransition } from "react-transition-group";
import {
  Wrapper,
  Container,
  Icon,
  Text,
} from "./styles/server-error-message-styles";

const ServerErrorMessage: FunctionComponent<unknown> = () => (
  <Wrapper>
    <CSSTransition in appear timeout={300} classNames="error-message-fade">
      <Container>
        <Icon>
          <FontAwesomeIcon icon={faExclamationTriangle} />
        </Icon>
        <Text>
          <strong>Server error</strong>
          <br />
          Error while submitting the form
        </Text>
      </Container>
    </CSSTransition>
  </Wrapper>
);

export default ServerErrorMessage;
